import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { netBalanceAt, fmtCompact, fmtMoney } from "@/lib/finance";
import { daysElapsed } from "@/lib/finance";

export const GrowthChart = ({ tranches, deductions = [] }) => {
  const maxAge = Math.max(1, ...tranches.map((t) => daysElapsed(t.injection_datetime)));
  const points = [];
  const steps = 40;
  for (let i = 0; i <= steps; i++) {
    const off = maxAge - (maxAge * i) / steps; // days ago
    points.push({
      day: `D-${Math.round(off)}`,
      balance: Math.max(netBalanceAt(tranches, deductions, off), 0),
    });
  }
  const current = points[points.length - 1]?.balance || 0;

  return (
    <div className="glass rounded-xl border border-[#232D40] p-5 sm:p-6" data-testid="growth-chart">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="font-heading text-lg font-semibold">Net Portfolio Growth</h2>
          <p className="text-xs text-slate-500">Compounded balance, net of deductions</p>
        </div>
        <span className="text-sm font-mono-data text-emerald-400">{fmtMoney(current, 0)}</span>
      </div>
      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={points} margin={{ left: -8, right: 8, top: 6 }}>
          <defs>
            <linearGradient id="goldFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#F59E0B" stopOpacity={0.5} />
              <stop offset="100%" stopColor="#F59E0B" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#232D40" vertical={false} />
          <XAxis dataKey="day" stroke="#64748B" fontSize={10} tickLine={false} axisLine={false} interval={6} />
          <YAxis stroke="#64748B" fontSize={10} tickLine={false} axisLine={false} tickFormatter={fmtCompact} width={56} />
          <Tooltip
            contentStyle={{ background: "#0B0E17", border: "1px solid #232D40", borderRadius: 10, fontFamily: "JetBrains Mono" }}
            labelStyle={{ color: "#94A3B8" }} formatter={(v) => [fmtMoney(v), "Net Balance"]}
          />
          <Area type="monotone" dataKey="balance" stroke="#F59E0B" strokeWidth={2.5} fill="url(#goldFill)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
